import { css } from 'linaria';
import { imageBaseWrapper } from './common-styles';

export const productNameTextInWidget = css`
  display: block !important;
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: var(--space-900);
  overflow-wrap: anywhere;
`;

export const productNameWithoutReviews = css`
  -webkit-line-clamp: 3;
`;

export const imageWrapper = imageBaseWrapper;

export const productInfoWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  &.list {
    flex-direction: row;
    min-height: 200px;
  }

  &.large-card {
    flex-direction: column;
    height: 100%;
  }

  @media (--only-mobile) {
    &,
    &.large-card,
    &.list {
      flex-direction: column;
      height: 100%;
    }
  }
`;

export const brandShelfItemStyle = css`
  width: 152px;
  height: 292px;
  background-color: var(--background-primary);
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  box-sizing: content-box;

  @media (--to-tablet) {
    width: 139px;
    padding: 16px;
  }
`;

export const brandShelfProductName = css`
  color: var(--text-primary);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.12px;
`;

export const sponsoredProductInfo = css`
  display: flex;
  gap: var(--space-50);
  flex-direction: column;
`;

export const sponsoredInfoProductWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const marginStyle = css`
  margin-bottom: var(--space-200);
`;
